module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZVop6z/tc-custom/9781035841424.jpg?1718106147938",
      "alt": "This image is the cover for the book Crossing the Lagan"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crossing the Lagan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This collection of short stories and vignettes is at once sad, humorous, and inspiring, set against the backdrop of the Diaspora. Woven from the recollections and experiences of childhood in a society divided by religion, expectations, despair, and hope, it tells the tales of those who crossed the Lagan in search of a better life. This canvas captures the fleeting nature of the Church’s influence and control, and the contempt for its hypocrisy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frederick Anthony Wilkinson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Belfast, educated in St. Marys Grammar School until aged 14 when the family left for a new life in Coventry where Frederick attended Ullathorne and Bablake Grammar Schools. On leaving University he travelled around the world, employed in a variety of jobs from teaching to working in mines, and Telecoms in Australia, Africa, Asia and America. On returning to UK, Frederick became sales director in Africa, Europe and Middle East. He was recruited by HRM to work in Poland, Ukraine and Russia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0